/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Resource
 * @desc Resource filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import FilterPostNewIndexResourceForm from './Form';
import type { FilterPostNewIndexResourceProps } from './types';

export const FilterPostNewIndexResource: React.FC<
  FilterPostNewIndexResourceProps
> = ({ addPostFilter, ...rest }) => (
  <Modal
    header={`Filter by ${Resource.getHumanReadableEntityName(false, true)}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.resource.primary}
        text="Resource used"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostNewIndexResourceForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
